/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Lifecycle_Delete_Empty_ProductInputs */

const en_lifecycle_delete_empty_product = /** @type {(inputs: Lifecycle_Delete_Empty_ProductInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} has no items. Deleting it cannot be undone.`)
};

const de_lifecycle_delete_empty_product = /** @type {(inputs: Lifecycle_Delete_Empty_ProductInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} enthält keine Vorgänge. Das Löschen lässt sich nicht rückgängig machen.`)
};

/**
* | output |
* | --- |
* | "{name} has no items. Deleting it cannot be undone." |
*
* @param {Lifecycle_Delete_Empty_ProductInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lifecycle_delete_empty_product = /** @type {((inputs: Lifecycle_Delete_Empty_ProductInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lifecycle_Delete_Empty_ProductInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_lifecycle_delete_empty_product(inputs)
	return en_lifecycle_delete_empty_product(inputs)
});